import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { useDispatch } from 'react-redux';
import { RouterProvider } from 'react-router-dom';

import useIndexedDBUuid from '@/hooks/useIndexedDBUuid';
import type { AppDispatch } from '@/store';

import './App.css';
import ToastContainer from './UI/toast/ToastContainer';
import { checkPlatform, getCookie } from './Utils/utils';
import { fetchVersionList } from './components/ManagementModal/version-download/useVersionDownload';
import DesktopTitleBar from './components/desktop-title-bar/DesktopTitleBar';
import NewTab from './components/new-tab';
import { PLATFORM, SESSION_STORAGE } from './constants/enum';
import { defaultLocale, dynamicActivate } from './i18n';
import router from './routes/router';

function App() {
    const dispatch = useDispatch<AppDispatch>();
    // void i18n;
    useIndexedDBUuid();

    const [newtab, setNewtab] = useState(false);
    const platform = checkPlatform();
    document.documentElement.setAttribute('data-platform', platform);

    useEffect(() => {
        dynamicActivate(defaultLocale);
    }, []);

    useEffect(() => {
        const broadcast = new BroadcastChannel('myChannelName');
        const isOpen = sessionStorage.getItem('appIsOpen');
        const myCookieValue = getCookie(SESSION_STORAGE.devicePassword);
        myCookieValue &&
            sessionStorage.setItem(
                SESSION_STORAGE.devicePassword,
                myCookieValue,
            );
        !isOpen && sessionStorage.setItem('appIsOpen', 'true');
        broadcast.postMessage({ appIsOpen: true });
        broadcast.onmessage = event => {
            if (event.data.appIsOpen) {
                setNewtab(true);
            }
        };
        dispatch(fetchVersionList());

        return;
    }, [dispatch]);

    return (
        <div className={`App`}>
            <I18nProvider i18n={i18n}>
                {newtab ? (
                    <NewTab />
                ) : (
                    <>
                        {platform === PLATFORM.DESKTOP && <DesktopTitleBar />}
                        <RouterProvider router={router} />
                    </>
                )}
            </I18nProvider>
            {ReactDOM.createPortal(
                <ToastContainer />,
                document.getElementById('toast-root'),
            )}
        </div>
    );
}

export default App;
